@if (!isComponentImported) {
  @if(error) {
    <div class="alert alert-danger">
      <strong>Error:</strong> {{ error }}
      <button class="btn btn-sm btn-secondary ml-2" (click)="refreshEvents()">
        Retry
      </button>
    </div>
  }
  <div>
    <div class="span9">
      <h1 data-automation-name="eventIndex">Events</h1>
    </div>
    <p class="lead">
      Events are dispatches received from a VTN that must contain a market
      context, and may contain some groups, resources, or parties. For a VEN to
      accept and opt into a VTN's event, the VEN must be associated to the Event's
      market context and associated with one group, resource, or party.
    </p>
  </div>
}
@if(isLoading) {
  <app-loader
    message="Loading Events...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <tr>
      @if (!isComponentImported) {
        <th>ID</th>
      }
      <th>EventID</th>
      <th>VEN</th>
      <th>Start time</th>
      <th>Duration</th>
      <th>Test Event</th>
      <th>Priority</th>
      <th>Tolerance</th>
      @if (!isComponentImported) {
        <th>Accepted</th>
        <th>Market Context</th>
        <th>Groups</th>
        <th>Resources</th>
        <th>Parties</th>
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      @if (!isComponentImported) {
        <th><input placeholder="ID" class="input-sm form-control" type="search" [(ngModel)]="idSearch" (input)="triggerSearch()"/></th>
      }
      <th><input placeholder="Event ID" class="input-sm form-control" type="search" [(ngModel)]="eventIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="VEN" class="input-sm form-control" type="search" [(ngModel)]="venIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Start Time" class="input-sm form-control" type="search" [(ngModel)]="startTimeSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Duration" class="input-sm form-control" type="search" [(ngModel)]="durationSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Test Event" class="input-sm form-control" type="search" [(ngModel)]="testSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Priority" class="input-sm form-control" type="search" [(ngModel)]="prioritySearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Tolerance" class="input-sm form-control" type="search" [(ngModel)]="toleranceSearch" (input)="triggerSearch()"/></th>
      @if (!isComponentImported) {
        <th>
          <select class="input-sm form-control" [(ngModel)]="acceptedSearch" (change)="triggerSearch()">
            <option value="">All</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
        </th>
        <th><input placeholder="Market Context" class="input-sm form-control" type="search" [(ngModel)]="marketContextSearch" (input)="triggerSearch()"/></th>
        <th><input placeholder="Group ID" class="input-sm form-control" type="search" [(ngModel)]="groupIdSearch" (input)="triggerSearch()"/></th>
        <th><input placeholder="Resource ID" class="input-sm form-control" type="search" [(ngModel)]="resourceIdSearch" (input)="triggerSearch()"/></th>
        <th><input placeholder="Party ID" class="input-sm form-control" type="search" [(ngModel)]="partyIdSearch" (input)="triggerSearch()"/></th>
        <th></th>  <!-- Actions column -->
      }
    </tr>
    </thead>
    <tbody>
      @for(event of displayedEvents | paginate: paginationModel; track event) {
        <tr>
          @if (!isComponentImported) {
            <td>{{ event.id }}</td>
          }
          <td>{{ event.event_id }}</td>
          <td>{{ event.ven_id }}</td>
          <td>{{ event.dtstart }}</td>
          <td>{{ event.duration }}</td>
          <td>{{ event.test }}</td>
          <td>{{ event.priority }}</td>
          <td>{{ event.tolerance }}</td>
          @if (!isComponentImported) {
            <td>
              <span class="badge"
                    [class.badge-success]="event.accepted"
                    [class.badge-secondary]="!event.accepted">
                {{ event.accepted ? 'Yes' : 'No' }}
              </span>
            </td>
            <td>{{ event.market_context?.market_context }}</td>
            <td>
              @for(group of event.groups; track group) {
                <div>{{ group.group_id }}:{{ group.division }}</div>
              }
            </td>
            <td>
              @for(resource of event.resources; track resource) {
                <div>{{ resource.resource_id }}:{{ resource.program_unit }}</div>
              }
            </td>
            <td>
              @for(party of event.parties; track party) {
                <div>{{ party.party_id }}</div>
              }
            </td>
            <td>
              <div class="btn-group">
                <a class="btn btn-default btn-sm"
                   (click)="nextPage(event.id, '/viewEvent', router)"
                   name="viewEvent">
                  View
                </a>
              </div>
            </td>
          }
        </tr>
      }

      @if(displayedEvents.length <= 0 && !isLoading) {
        <tr>
          <td [attr.colspan]="colspan" style="text-align: center;">No Events.</td>
        </tr>
      }
    </tbody>

    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="colspan">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}


